//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { db } from "../main.js";
export default {
  name: "Admin",
  data() {
    return {
      listViewMode: "table",
      isCreatingClass: false,
      isCreatingInstructor: false,
      editKey: null,
      classes: null,
      instructors: null,
      newClass: {
        name: "New Class",
        style: "none",
        level: "none",
        classtype: "none",
        dance: "none",
        instructor: "none",
        YTID: "DkfRfZY5HwA",
        thumbnail: "Chacha-Amanda375-thumbnail.png",
      },
      newInstructor: {
        uid: "Amanda375",
        name: "Amanda",
        website: "https://375dancestudio.com",
        studio: "375 Studio",
        picURL:
          "https://yt3.ggpht.com/ytc/AKedOLSt_h6uCeMdzFKEz84I3CM1QTrOmtb5twd_sX2B=s176-c-k-c0x00ffffff-no-rj-mo",
        description: `
I started dancing when`,
      },
    };
  },
  computed: {},
  methods: {
    addClass(data) {
      var id = db.ref().child("classes").push().key;
      db.ref("classes/" + id).set(data);
      db.ref("classes/" + id + "/classid").set(id);
      this.isCreatingClass = false;
    },
    addInstructor(data) {
      db.ref(`instructors/${data.uid}`).set(data);
      this.isCreatingInstructor = false;
    },
    deleteInstructor(key) {
      db.ref(`instructors/${key}`).remove();
    },
    toggleView(activeIndex) {
      activeIndex == "toc"
        ? (this.listViewMode = "table")
        : (this.listViewMode = "card");
    },
  },
  created() {
    db.ref()
      .child("classes")
      .on("value", (snapshot) => {
        this.classes = snapshot.val();
      });
    db.ref("instructors").on("value", (snapshot) => {
      this.instructors = snapshot.val();
    });
  },
};
